import React from 'react';

const PrevButton = () => {
	return (
		<div>
			<a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
				<span className="carousel-control-prev-icon" aria-hidden="true" />
				<span className="sr-only">Previous</span>
			</a>
		</div>
	);
};

export default PrevButton;
